export default "__VITE_ASSET__BB529mWu__"